import { render, staticRenderFns } from "./TaskCreate.vue?vue&type=template&id=ea119e5c&scoped=true"
import script from "./TaskCreate.vue?vue&type=script&lang=js"
export * from "./TaskCreate.vue?vue&type=script&lang=js"
import style0 from "./TaskCreate.vue?vue&type=style&index=0&id=ea119e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea119e5c",
  null
  
)

export default component.exports